import { render, staticRenderFns } from "./Booklog.vue?vue&type=template&id=ffb2d876&"
import script from "./Booklog.vue?vue&type=script&lang=js&"
export * from "./Booklog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports